"use client";

import { useRouter } from "next/navigation";
import type { ReactNode } from "react";
import { IoArrowBackCircle } from "react-icons/io5";

import { cn } from "@/utils/lib";

interface BountyPageHeaderProps {
  showBackIcon?: boolean;
  children?: ReactNode;
  url?: string;
  className?: string;
}

const BountyPageHeader = ({
  showBackIcon = true,
  children,
  url,
  className = "",
}: BountyPageHeaderProps) => {
  const router = useRouter();

  return (
    <section
      className={cn("flex w-full items-center justify-between", className)}
    >
      {showBackIcon && (
        <div className="relative w-10">
          <IoArrowBackCircle
            className="
              absolute top-0 left-6 z-10 size-8 cursor-pointer
              hover:text-primary
            "
            onClick={() => (url ? router.push(url) : router.back())}
          />
        </div>
      )}

      <div>{children}</div>

      {showBackIcon && <div className="w-10" />}
    </section>
  );
};

export default BountyPageHeader;
